export default __webpack_public_path__ + "static/jeroen-bartels-c73fca8ec964cd8a21520b51e2623ca9.jpg";